import React from 'react';
import { useState, useEffect } from 'react';
import { flowRight } from 'lodash/fp';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import UserForm from './UserForm';
import { loadUserNew, saveUser, loadCompany } from './services';

let CreateUser = props => {
    const { match } = props;
    const { company_id: companyId } = match.params;
    const { history, enqueueSnackbar } = props;
    const [additionalData, setAdditionalData] = useState({
        portalUsers: [],
        companyUsers: [],
        companyGroups: [],
        roles: [],
    });

    const [saving, setSaving] = useState(false);
    const [serverSideErrors, setServerSideErrors] = useState({});

    useEffect(() => {
        loadUserNew(companyId).then(
            ({ roles, groups, users, companyUsers }) => {
                setAdditionalData({
                    roles,
                    companyGroups: groups,
                    portalUsers: users,
                    companyUsers,
                });
                loadCompany(companyId).then(company =>
                    props.updateBreadcrumbs([
                        { name: 'Companies', path: '/companies' },
                        {
                            name: company.business_name,
                            path: `/companies/${companyId}`,
                        },
                        'New User',
                    ])
                );
            }
        );
    }, []);

    const handleSave = userDetails => {
        setSaving(true);
        saveUser(userDetails, companyId).then(json => {
            if (json.error) {
                const userNameError = json.error === 'Invalid media provided';
                setServerSideErrors({
                    partner_portal_username_taken: userNameError,
                    email: !userNameError,
                });
                setSaving(false);
            } else {
                enqueueSnackbar('Partner portal access will be added', {
                    variant: 'info',
                });
                history.push(`/companies/${companyId}/partner/access`);
            }
        });
    };

    return (
        <UserForm
            editable={true}
            onSave={handleSave}
            saving={saving}
            additionalData={additionalData}
            serverSideErrors={serverSideErrors}
            companyId={companyId}
        />
    );
};

export default flowRight(withSnackbar, withRouter)(CreateUser);
